var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRpps = function SvgRpps(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "rotate(180 8 8)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#1E88E5",
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 1.75)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.5,
    height: 4.5,
    x: 6,
    y: 4,
    fill: "#FFF",
    rx: 2.25
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.5,
    height: 4.5,
    fill: "#FFF",
    rx: 2.25
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.5,
    height: 4.5,
    y: 8,
    fill: "#FFF",
    rx: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 1.5,
    d: "m2.25 10.25 6-4-6-4"
  })))));
};
export default SvgRpps;